import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

import Analytics from './Analytics';
// const Analytics = Loadable(lazy(() => import('./Analytics')));

const Reviews = Loadable(lazy(() => import('./ReviewsScreen')));
const Logs = Loadable(lazy(() => import('./Logs')));

const dashboardRoutes = [
  { path: '/dashboard/default', element: <Analytics />, auth: authRoles.admin },
  // { path: '/dashboard/default', element: <><Dashboard /></>, auth: authRoles.admin },
  { path: '/product/reviews', element: <Reviews />, auth: authRoles.admin },
  { path: '/dashboard/logs', element: <Logs />, auth: authRoles.admin },
];

export default dashboardRoutes;
